import { render, staticRenderFns } from "./roleAdmin.vue?vue&type=template&id=18fd3af2&scoped=true&"
import script from "./roleAdmin.vue?vue&type=script&lang=js&"
export * from "./roleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./roleAdmin.vue?vue&type=style&index=0&id=18fd3af2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd3af2",
  null
  
)

export default component.exports